import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { fetchBankSlips } from 'slices/financial'
import { BILLS_TAGS, DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { STATICS } from 'statics'
import { useFirebaseEvent } from 'hooks'
import { PaymentButton } from 'components/payment-button'
import { Button } from 'components/button'
import './style.scss'

export function Success() {
  const [slip, setSlip] = useState({})
  const { sendEvent } = useFirebaseEvent()
  const { bankSlips } = useSelector(state => state.financial)
  const { selected } = useSelector(state => state.contract)
  const idContract = selected.id
  const dispatch = useDispatch()

  useEffect(() => {
    const negotiatedSlip = bankSlips.content.find(({ tags }) =>
      tags?.includes(BILLS_TAGS.BREACH_OF_AGREEMENT)
    )

    setSlip(negotiatedSlip || {})
  }, [bankSlips])

  useEffect(() => {
    dispatch(fetchBankSlips(idContract))
  }, [idContract, dispatch])

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.BILLET_NEGOTIATION_SUCCESS)
  }, [sendEvent])

  function handleGoHomeClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderPayments() {
    const { id } = slip
    if (!id) return null

    return (
      <div className='container-payments'>
        <span className='title'>Pague agora</span>
        <PaymentButton invoiceId={id} event={FIREBASE_EVENTS.CLICK_ON_PAYMENT_DRAWER_NEGOTIATION} />
      </div>
    )
  }

  function renderActions() {
    return (
      <div className='container-buttons'>
        <Button onClick={handleGoHomeClick} outlined className='button home' color='primary'>
          Voltar para home
        </Button>
      </div>
    )
  }

  return (
    <div className='container-success'>
      <div className='container-info'>
        <div className='container-icon'>
          <STATICS.SUCCESS />
        </div>
        <span className='title'>Negociação confirmada!</span>
        <div className='container-description'>
          <span className='description'>
            Esta negociação foi concluída e gerou um novo boleto que{' '}
            <strong>deve ser pago até o próximo dia útil</strong>
          </span>
          <span className='description'>
            Caso seu pagamento não seja identificado, esta{' '}
            <strong>negociação será cancelada</strong> e suas faturas voltarão a ser cobradas!
          </span>
          <span className='description'>
            Se a sua negociação foi parcelada, não se preocupe porque as demais parcelas virão junto
            com as faturas seguintes.
          </span>
        </div>
      </div>
      {renderPayments()}
      {renderActions()}
    </div>
  )
}
